// Estado en memoria del odontograma (033) mientras se edita en pantalla —
// separado del wire format server (`DatosOdontogramaPdf` de `@logiacare/hce-pdf`,
// que es una lista dispersa) para que la UI pueda indexar por pieza en O(1).
// Ver PLAN.md sección "033" para el detalle completo de la leyenda/campos.
import type { CodigoHallazgoOdontograma, SuperficiesPieza } from '@logiacare/hce-pdf';

export interface EntradaOdontogramaUi {
  readonly hallazgo?: CodigoHallazgoOdontograma;
  /** Grado 1-4 (clasificación de Miller), independiente del hallazgo. */
  readonly recesion?: number;
  /** Grado 1-3 (Miller modificado, instructivo 033), independiente del hallazgo. Solo dientes definitivos. */
  readonly movilidad?: number;
  /** Caries (rojo) / obturación (azul) por superficie. Sin esta clave, un `hallazgo` 'caries'/'obturado' de datos viejos vale para la pieza completa. */
  readonly superficies?: SuperficiesPieza;
}

/** Piezas FDI (permanentes + temporales) → dato capturado. Sin entrada = "sano", sin recesión ni movilidad. */
export type EstadoOdontograma = Readonly<Record<string, EntradaOdontogramaUi>>;

export const ESTADO_ODONTOGRAMA_VACIO: EstadoOdontograma = {};
